import { useTranslation } from 'react-i18next'
import useAppConfiguration from '@client-hub/shared/react/hooks/useAppConfiguration'
import LegalDocBase from 'components/LegalDocBase'

const TermsOfService = () => {
  const { t } = useTranslation()
  const { tosDocLink, isLoading } = useAppConfiguration()
  return <LegalDocBase doc={{ link: tosDocLink, loading: isLoading }} title={t('routes.termsOfService.heading')} />
}

export default TermsOfService
